import bgImage from '../../../../static/images/app-development/services/carousel-bg.png';

import { CarouselTypes } from './consts';

const typeToCursorMap = ({ type, content, withButtons }) => {
    if (content.length === 1 || withButtons) {
        return 'default';
    }
    if (
        (type === CarouselTypes.CASE_STUDIES ||
            type === CarouselTypes.SERVICES ||
            type === CarouselTypes.WORKSHOP_PROCESS) &&
        content.length > 1
    ) {
        return 'initial';
    } else {
        return 'none!important';
    }
};

export const mainContainer = ({ content, type, withButtons }) => ({
    tabletLarge: {
        cursor: typeToCursorMap({ type, content, withButtons }),
    },
});

export const container = ({ isServices }) => ({
    overflow: 'hidden',

    outline: '0',
    ...(!isServices && {
        marginRight: '-2rem',
    }),
    position: 'relative',

    tablet: {
        marginRight: '0',
    },
});

export const extendContainer = ({ isServices }) => {
    return {
        container: ({ isHomePage, noPaddingBottom }) => ({
            ...(noPaddingBottom && {
                paddingBottom: 0,
                tabletLarge: {
                    paddingBottom: 0,
                },
            }),

            ...(isServices && {
                backgroundImage: !isHomePage && `url(${bgImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '90% 2rem',
            }),
        }),
    };
};
